<div class="container d-flex flex-column flex-md-row align-items-center justify-content-between">
  <div class="text-dark order-2 order-md-1">
    algoleague © All Rights Reserved {{ currentYear }} -
    <a
      *ngIf="releaseNotesEnabled; else plainVersion"
      routerLink="/release-notes"
      class="text-dark text-hover-primary"
      title="Release Notes"
    >
      {{ currentVersion }}
    </a>
    <ng-template #plainVersion>{{ currentVersion }}</ng-template>
  </div>
  <div class="nav nav-dark order-1 order-md-2">
    <a
      *ngFor="let page of footerPages"
      [routerLink]="'/page/' + page.slug"
      target="_blank"
      class="nav-link pr-3 pl-0"
      [innerText]="page.name"
    ></a>
    <a routerLink="/page/contact-us" target="_blank" class="nav-link pl-3 pr-0">{{
      '::ContactUs' | abpLocalization
    }}</a>
    <a
      *ngIf="releaseNotesEnabled"
      routerLink="/release-notes"
      target="_blank"
      class="nav-link pl-3 pr-0"
      >Release Notes</a
    >
  </div>
</div>
